import * as React from "react";
import {Howl} from 'howler';
import {Button} from 'reactstrap';
import {navigate} from '@reach/router';

import {getArtistCookie, hasAnoAccess} from '../data/page_data';

export default class PodcastItem extends React.Component {
    //playBtn = 'http://resources.triyakom.com/mini_portal/play.png';
    //pauseBtn = 'http://resources.triyakom.com/mini_portal/pause.png';
    playBtn = (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47 46.994">
        <path
            d="M24.175,17.078,14.416,9.983a1.177,1.177,0,0,0-1.869.949V25.117a1.173,1.173,0,0,0,.643,1.049,1.185,1.185,0,0,0,.535.127,1.17,1.17,0,0,0,.691-.228l9.759-7.088a1.167,1.167,0,0,0,0-1.9Z"
            transform="translate(7.077 5.5)"/>
        <path
            d="M23.5,0A23.5,23.5,0,1,0,47,23.5,23.5,23.5,0,0,0,23.5,0Zm0,43.073A19.575,19.575,0,1,1,43.073,23.5,19.572,19.572,0,0,1,23.5,43.075Z"
            transform="translate(0 -0.002)"/>
    </svg>);
    pauseBtn = (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47 46.994">
        <path
            d="M23.5,0A23.5,23.5,0,1,0,47,23.5,23.5,23.5,0,0,0,23.5,0Zm0,43.073A19.575,19.575,0,1,1,43.073,23.5,19.572,19.572,0,0,1,23.5,43.075Z"
            transform="translate(0 -0.002)"/>
        <g transform="translate(15 15)">
            <path
                d="M5.7,0H.814A.814.814,0,0,0,0,.814V15.465a.814.814,0,0,0,.814.814H5.7a.814.814,0,0,0,.814-.814V.814A.814.814,0,0,0,5.7,0Z"/>
            <path
                d="M197.7,0h-4.884A.814.814,0,0,0,192,.814V15.465a.814.814,0,0,0,.814.814H197.7a.814.814,0,0,0,.814-.814V.814A.814.814,0,0,0,197.7,0Z"
                transform="translate(-182.233)"/>
        </g>
    </svg>);

    constructor(props) {
        super(props);
        this.cookie = getArtistCookie();
    }

    state = {
        active: '',
        playBtn: this.playBtn,
        progress: '0%',
        minute: '00:00',
        duration: '00:00'
    };

    toggleAudio = () => {

        let howler;
        let icon;
        if (!this.state.howler) {
            if (!this.cookie) {
                if (!hasAnoAccess(this.props.artist)) {
                    navigate('join');
                    return;
                }
            }
            howler = new Howl({
                src: [this.props.data.pod_url],
                autoplay: true,
                loop: false,
                volume: 1,
                onload: () => {
                    this.setState({duration: this.toTime(howler.duration())})
                },
                onplay: () => {
                    this.setProgress(0);
                    this.setState({playBtn: this.pauseBtn});
                    requestAnimationFrame(this.seekMe);
                },
                onpause: () => {
                    this.setState({playBtn: this.playBtn});
                },
                onend: () => {
                    this.setState({playBtn: this.playBtn});
                    this.setProgress(100);
                }
            });
            this.setState({howler: howler, active: 'podcast-active', playBtn: this.pauseBtn},
            );
            howler.play();
            this.props.fnStopCurrentAudio();
            this.props.fnCurrentAudio(this);
        } else {
            if (this.state.active == '') {
                this.props.fnStopCurrentAudio();
                this.props.fnCurrentAudio(this);
                this.setState({active: 'podcast-active'});
            }
            if (this.state.howler.playing()) {
                this.state.howler.pause();
            } else {
                this.state.howler.play();
            }
        }
    }


    setProgress = (progress, seek = 0) => {
        this.setState({progress: progress + '%', minute: this.toTime(seek)});
    }

    seekMe = () => {
        let seek = this.state.howler.seek() || 0;
        let duration = this.state.howler.duration();
        let progress = ((seek / duration) * 100) || 0;

        if (this.state.howler.playing()) {
            this.setProgress(progress, seek);
            requestAnimationFrame(this.seekMe);
        }
    }

    toTime = (d) => {
        d = Number(d);

        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);

        return ('0' + m).slice(-2) + ":" + ('0' + s).slice(-2);
    }

    stop = () => {
        if (this.state.howler) this.state.howler.stop();
        this.setState({active: '', playBtn: this.playBtn});
    }

    render() {
        return <li className={this.state.active}>
              <span className="hp-left">
                <Button color="none" className="btn-control-podcast" onClick={this.toggleAudio}>
                    {this.state.playBtn}
                    </Button>
              </span>
            <span className="hp-right">
                <div className="hpr-top">
                  <span className="hprt-left">
                    <div>{this.props.data.title}</div>
                    <div>{this.props.data.artist}</div>
                  </span>
                  <span className="hprt-right">
                    <div className="podcast-time">{this.props.data.pod_time}</div>
                    <Button color="none" className="btn-podcast-share">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46">
                        <g transform="translate(-237.041 -1076)">
                          <rect className="a" rx="5" width="100%" transform="translate(237.041 1076)"/>
                          <g className="b" transform="translate(247.707 1085.636)">
                            <path
                                d="M-492.652,97.374h0a2.048,2.048,0,0,0-1.769.24l-9.147,6.137-4.452,2.987h0l-6.755,4.533a2.418,2.418,0,0,0-1.06,2.212,2.417,2.417,0,0,0,1.216,1.9l4.183,1.852v-.023a1.188,1.188,0,0,0,1.027-.306l10.475-9.958a.278.278,0,0,1,.287-.057.284.284,0,0,1,.193.27.27.27,0,0,1-.076.188l-9.362,10.184a.6.6,0,0,0-.156.406v5.134a1.777,1.777,0,0,0,.892,1.574,1.731,1.731,0,0,0,1.317.153,1.731,1.731,0,0,0,1.039-.823l1.87-3.369,5.053,2.25a2.407,2.407,0,0,0,2.136-.089,2.407,2.407,0,0,0,1.222-1.754l3.239-21.39a1.931,1.931,0,0,0,.023-.308A2.039,2.039,0,0,0-492.652,97.374Zm-13.2,26.015a.535.535,0,0,1-.311.249.523.523,0,0,1-.42-.048.6.6,0,0,1-.268-.524v-4.21l2.819,1.256Zm13.384-23.958h0l-3.239,21.4a1.209,1.209,0,0,1-.62.885,1.192,1.192,0,0,1-1.062.043l-9.055-4.034,8.795-9.565a1.484,1.484,0,0,0-.049-2.062,1.484,1.484,0,0,0-2.062-.022l-10.474,9.96-3.692-1.648a1.219,1.219,0,0,1-.713-1.008,1.219,1.219,0,0,1,.533-1.113l20.354-13.656a.836.836,0,0,1,.859-.038.835.835,0,0,1,.438.74A.67.67,0,0,1-492.467,99.431Z"
                                transform="translate(515.844 -97.272)" strokeWidth="0.5"/>
                          </g>
                        </g>
                      </svg>
                      </Button>
                  </span>
                </div>
                <div className="hpr-bottom">
                  <div className="progress">
                      <div className="progressFill" style={{
                          height: '100%',
                          width: this.state.progress,
                          backgroundColor: 'var(--podcast-progress-color)'
                      }}></div>
                      <span className="podcast-time-start">{this.state.minute}</span>
                        <span className="podcast-time-all">{this.state.duration}</span>

                  </div>
                </div>
              </span>
        </li>
            ;
    }
}